var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgProfiles = function SvgProfiles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 22.572C0 17.837 3.74 14 8.357 14h4.286C17.26 14 21 17.836 21 22.572c0 .789-.624 1.428-1.393 1.428H1.393C.623 24 0 23.361 0 22.572M28.561 24h-6.464c.253-.451.403-.976.403-1.538v-.385a9.699 9.699 0 0 0-3.272-7.299c.112-.004.22-.009.332-.009h2.879c4.176 0 7.561 3.471 7.561 7.754 0 .819-.647 1.477-1.439 1.477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 6A6 6 0 1 1 5 6a6 6 0 0 1 12 0m3.75 6a5.241 5.241 0 0 1-3.718-1.542A7.46 7.46 0 0 0 18.5 6a7.45 7.45 0 0 0-.857-3.483A5.25 5.25 0 0 1 20.75 1.5 5.247 5.247 0 0 1 26 6.75 5.247 5.247 0 0 1 20.75 12",
    opacity: 0.404
  }))));
};
export default SvgProfiles;